const fitMapToBounds = (map, bounds, padding = 20) => {
  const options = { duration: 0, padding };
  // Fit map to bounds if bounds are valid
  if (!bounds.isEmpty()) {
    map.fitBounds(bounds, options);
  }
};

export { fitMapToBounds };
